<template>

  <div class="duration-picker">
    <v-text-field
      v-model="date[0]"
      :label="$t('date') "
      @blur="onDateTimeEdit(0)"
      @focus="$event.target.select()"
      data-test="date"
    ></v-text-field>

    <template v-for="(item, index) in dtimes">
      {{ date[index] !== date[0] ? date[index] : '' }}
      <v-text-field
        v-model="time[index]"
        :key="index"
        :label="$t($store.state.site.modules.mnt.interventionTimesLabels[index].toLowerCase())"
        @blur="onDateTimeEdit(index)"
        @focus="$event.target.select()"
        data-test="time"
      ></v-text-field>
    </template>

    <v-btn text block v-if="!allTimes" @click="addNextInterventionTime()">{{ $t('interventions.add-current-time') }}</v-btn>
  </div>

</template>

<script>
import moment from 'moment'

export default {
  props: {
    dtimes: Array // Array of Strings
  },
  data () {
    return {
      date: [], // Array of Strings
      time: [] // Array of Strings
    }
  },
  mounted () {
    this.sliceDtimes(this.dtimes)
  },
  computed: {
    allTimes () {
      return this.dtimes.indexOf(null) < 0
    }
  },
  methods: {
    sliceDtimes (val) {
      // Set date [] and time []
      let date = []
      let time = []
      for (let i in val) {
        date.splice(i, 1, val[i] ? moment(val[i]).format('D.M.YYYY') : '')
        time.splice(i, 1, val[i] ? moment(val[i]).format('HH:mm') : '')
      }
      this.date = date
      this.time = time
    },
    // Computations
    guessDate (val) { // Validates String, returns String
      return moment(val, 'D.M.YYYY').isValid() ? moment(val, 'D.M.YYYY').format('D.M.YYYY') : ''
    },
    guessTime (val) { // Validates String, returns String
      return moment(val, 'HH:mm').isValid() ? moment(val, 'HH:mm').format('HH:mm') : ''
    },
    guessDateTime (i) {
      let date = this.date[i]
      let time = this.time[i]
      // If no date is set (but time is), use initially the date[O] (if set)
      // ...if date[0] is not set, use initially today
      if (time && !date) {
        date = this.date[0] ? this.date[0] : moment().format('D.M.YYYY')
      }
      // If no time is set, remove the date (except for i==0)
      // ... This means that when time is deleted, the date should also be deleted
      if (!time && i !== 0) {
        date = ''
      }
      // return
      return this.compileStringsToDateTime(this.guessDate(date), this.guessTime(time))
    },
    compileStringsToDateTime (dateX, timeX) { // Accepts Strings, returns Moment
      if (dateX && timeX) {
        let date = moment(dateX, 'D.M.YYYY H:mm')
        let hours = moment(timeX, 'H:mm').hour()
        let minutes = moment(timeX, 'H:mm').minute()
        date.hour(hours)
        date.minute(minutes)
        return date
      }
      return moment.invalid()
    },
    compileDateTimeToString (dateTime) { // Accepts Moment, returns String
      return moment(dateTime).isValid() ? dateTime.format() : ''
    },
    // FE Actions
    onDateTimeEdit (i) {
      // Prepare an array of Moments for saving the changed results
      let newDtimes = []
      // Guess DateTime (for all fields as we need these values for recursive adjustments that follow)
      for (let i in this.dtimes) {
        newDtimes[i] = this.guessDateTime(i)
      }
      // Adjust other dateTimes to keep sequence rules
      if (newDtimes[i].isValid()) {
        // 1. Move 1 day later if set before the previous dateTime
        let j = i
        while (j > 0 && newDtimes[j - 1].isValid()) {
          let diff = newDtimes[j].diff(newDtimes[j - 1], 'days', true)
          if (diff < 0 || diff >= 1) {
            // Adjust date
            newDtimes[j].add(Math.ceil(-diff), 'days') // Math.ceil = round up
          }
          j--
        }
        // 2. Move successor by the same offset as this has been moved (and call this recursively)
        if (newDtimes[i].isValid() && this.dtimes[i]) {
          let offset = newDtimes[i].diff(moment(this.dtimes[i])) // Offset in milliseconds (to be applied)
          let k = i
          while (k < newDtimes.length - 1 && newDtimes[k + 1].isValid()) {
            newDtimes[k + 1].add(offset)
            k++
          }
        }
      }
      // Convert DateTimes to Strings and emit the entire array
      let result = []
      for (let i in this.dtimes) {
        result[i] = this.compileDateTimeToString(newDtimes[i])
      }
      this.$emit('changed', result)
    },
    addNextInterventionTime () {
      const index = this.dtimes.map(time => !!time ? time : null).indexOf(null)

      if (index >= 0)
        this.$emit('changed', this.dtimes.map((value, ix) => ix === index ? moment().format() : value))
    },
  },
  watch: {
    dtimes (val, oldVal) {
      this.sliceDtimes(val)
    }
  }
}
</script>
